import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content", "chevron"]
    static classes = ["open"]
    static values = {
        open: { type: Boolean, default: false },
        duration: { type: Number, default: 200 }
    }

    connect() {
        this.setupInitialState()
    }

    setupInitialState() {
        if (!this.openValue) {
            this.contentTargets.forEach(content => {
                content.style.maxHeight = "0"
                content.style.overflow = "hidden"
                content.classList.add("opacity-0")
            })
        }
    }

    toggle() {
        this.openValue = !this.openValue
        this.updateDisplay()
    }

    updateDisplay() {
        this.contentTargets.forEach(content => {
            if (this.openValue) {
                // Opening
                content.style.maxHeight = content.scrollHeight + "px"
                content.classList.remove("opacity-0")
                content.classList.add("opacity-100")
            } else {
                // Closing
                content.style.maxHeight = "0"
                content.classList.add("opacity-0")
                content.classList.remove("opacity-100")
            }
        })

        // Rotate chevron
        this.chevronTargets.forEach(chevron => {
            if (this.openValue) {
                chevron.style.transform = "rotate(180deg)"
            } else {
                chevron.style.transform = "rotate(0deg)"
            }
        })
    }

    openValueChanged() {
        this.updateDisplay()
    }
} 